export default __webpack_public_path__ + "static/creditline-banner-517af4ec986f693044009229cd579b51.webp";